import React, { Component } from 'react'
import { Link, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import classNames from 'classnames'
import DocumentEvents from 'react-document-events'

import { getCurrentUser } from '../../../ducks/users'
import Icon from '../../Shared/Icon'

class UserInfo extends Component {
  state = { expanded: false }

  handleLogout = () => {
    window.localStorage.removeItem('protonSession')
    window.location = '/'
  }

  handleToggle = () => {
    this.setState(state => ({ expanded: !state.expanded }))
  }

  getBaseURL = () => {
    const { location } = this.props
    const match = location.pathname.match(/^\/apps\/([\w\-]+)/)

    if (match) {
      const appId = match[1]

      return `/apps/${appId}/screens`
    }

    return ''
  }

  getSettingsLink = () => {
    const baseURL = this.getBaseURL()

    return `${baseURL}/settings/account`
  }

  getDevelopersLink = () => {
    const baseURL = this.getBaseURL()

    return `${baseURL}/developers/libraries`
  }

  render() {
    const { user } = this.props
    const { expanded } = this.state

    if (!user) {
      return null
    }

    return (
      <div className="navbar-user-info">
        {expanded ? <DocumentEvents onClick={this.handleToggle} /> : null}
        <a className="navbar-user-avatar" onClick={this.handleToggle}>
          <Icon big type="account-circle" />
          <Icon type="expand-vertical" />
        </a>
        {expanded ? (
          <div
            onClick={this.handleToggle}
            className={classNames('navbar-user-menu', { expanded })}
          >
            <Link to={this.getSettingsLink()}>Settings</Link>
            <hr />
            <a
              href="https://help.adalo.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              Help & Documentation
            </a>
            <hr />
            {user?.developer ? (
              <>
                <Link to={this.getDevelopersLink()}>Developers</Link>
                <hr />
              </>
            ) : null}
            {user.admin ? (
              <React.Fragment>
                <Link to="/admin/users">Admin</Link>
                <hr />
              </React.Fragment>
            ) : null}
            <a onClick={this.handleLogout}>Sign Out</a>
          </div>
        ) : null}
      </div>
    )
  }
}

const mapStateToProps = state => ({
  user: getCurrentUser(state),
})

export default withRouter(connect(mapStateToProps)(UserInfo))
